import { render, staticRenderFns } from "./IconPoiWinery.vue?vue&type=template&id=4b04fb4a&"
import script from "./IconPoiWinery.vue?vue&type=script&lang=js&"
export * from "./IconPoiWinery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports